import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faMapMarked,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { companyInfoTable } from "../firebase/content";
import Editable from "./Editable";
import AlertContactSubmit from "./AlertContactSubmit";
import { sendContact } from "../firebase/contact";
import Agencies from "../components/Agencies";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contactInfo: {
        name: "",
        phone: "",
        email: "",
        text: "",
      },
      errors: {},
      showAlert: false,
      openAgencyModal: false,
    };
    this.onValidate = this.onValidate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChange(field) {
    return (event) =>
      this.setState({
        contactInfo: { ...this.state.contactInfo, [field]: event.target.value },
      });
  }

  onValidate(event) {
    event.preventDefault();
    // console.log("validated !", this.state.contactInfo);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { name, phone, email, text } = this.state.contactInfo;
    const errors = {};

    // validate name
    if (!name || name.trim().length < 2) {
      errors.name = "Vui lòng nhập họ tên (tối thiểu 2 ký tự).";
    }

    //validate phone number
    const digitsCount = (phone.match(/\d/g) || []).length;
    if (!phone || digitsCount < 9) {
      errors.phone = "Vui lòng nhập số điện thoại hợp lệ (ít nhất 9 chữ số).";
    }

    //validate email
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,24}$/i.test(email)) {
      errors.email = "Vui lòng nhập email hợp lệ.";
    }

    //Validate text
    if (!text || text.trim().length < 10) {
      errors.text = "Vui lòng nhập lời nhắn (tối thiểu 10 ký tự).";
    }

    // If any errors, show them and stop
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, showAlert: false });
      return;
    }

    //Passed
    const contactInfo = {
      name: name.trim(),
      phone: phone.trim(),
      email: email.trim(),
      text: text.trim(),
    };

    // console.log("contactInfo", contactInfo);
    sendContact(contactInfo);

    // reset form , clear errors and show alert
    this.setState({
      contactInfo: {
        name: "",
        phone: "",
        email: "",
        text: "",
      },
      errors: {},
      showAlert: true,
    });
  }

  render() {
    let { editable } = this.props;
    let { [companyInfoTable]: companyInfo } = this.props.content;
    companyInfo = companyInfo || {};
    const { contactInfo, errors } = this.state;
    return (
      <div className="contact-section" id="contact">
        <Container>
          <h1>LIÊN HỆ</h1>
          <Row className="contact-section-content">
            <Col md={6} className="contact-info">
              {(companyInfo.factories || []).map((factory) => {
                return (
                  <section key={factory.id}>
                    <h3>Nhà Xưởng</h3>

                    <Editable
                      editable={editable}
                      object={factory}
                      field="address"
                    >
                      <p>
                        <FontAwesomeIcon icon={faMapMarked} /> {factory.address}
                      </p>
                    </Editable>
                    <Editable
                      editable={editable}
                      object={factory}
                      field="phone"
                    >
                      <p>
                        <FontAwesomeIcon icon={faPhone} /> {factory.phone}
                      </p>
                    </Editable>
                    <Editable
                      editable={editable}
                      object={factory}
                      field="email"
                    >
                      <p>
                        <FontAwesomeIcon icon={faEnvelope} /> {factory.email}
                      </p>
                    </Editable>
                  </section>
                );
              })}
              {(companyInfo.offices || []).map((office) => {
                return (
                  <section key={office.id}>
                    <h3>Văn Phòng</h3>

                    <Editable
                      editable={editable}
                      object={office}
                      field="address"
                    >
                      <p>
                        <FontAwesomeIcon icon={faMapMarked} /> {office.address}
                      </p>
                    </Editable>
                    <Editable editable={editable} object={office} field="phone">
                      <p>
                        <FontAwesomeIcon icon={faPhone} /> {office.phone}
                      </p>
                    </Editable>
                    <Editable editable={editable} object={office} field="email">
                      <p>
                        <FontAwesomeIcon icon={faEnvelope} /> {office.email}
                      </p>
                    </Editable>
                  </section>
                );
              })}
              <button
                className="btn btn-agencies"
                onClick={() => this.setState({ openAgencyModal: true })}
              >
                Liên Hệ Đại Lý
              </button>
              <Agencies
                isOpen={this.state.openAgencyModal}
                onHide={() => this.setState({ openAgencyModal: false })}
                editable={editable}
              />
            </Col>

            {/* CONTACT FORM */}
            <Col md={6} className="contact-form">
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="input-name">
                  <Form.Label>
                    <strong>Tên của quý khách</strong>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Họ và tên"
                    value={contactInfo.name}
                    onChange={this.onChange("name")}
                    isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="input-phone">
                  <Form.Label>
                    <strong>Số Điện Thoại</strong>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Số Điện Thoại"
                    value={contactInfo.phone}
                    onChange={this.onChange("phone")}
                    isInvalid={!!errors.phone}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phone}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="input-email">
                  <Form.Label>
                    <strong>Email</strong>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    value={contactInfo.email}
                    onChange={this.onChange("email")}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="input-text">
                  <Form.Label>
                    <strong>Lời nhắn</strong>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows="3"
                    value={contactInfo.text}
                    onChange={this.onChange("text")}
                    isInvalid={!!errors.text}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.text}
                  </Form.Control.Feedback>
                </Form.Group>
                <Button className="contact-btn" type="submit">
                  Gửi
                </Button>
              </Form>

              {this.state.showAlert && <AlertContactSubmit />}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
  };
};

export default connect(mapStateToProps)(Contact);
